if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
  });
  

  $(".gallery-block .primary-slider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: false,
    arrows: true,
    asNavFor: '.gallery-block .top-slider, .gallery-block .bottom-slider, .gallery-block .top-right-slider',
  });

  $(".gallery-block .top-slider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: false,
    arrows: false,
  });

  $(".gallery-block .top-right-slider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: false,
    arrows: false,
  });

  $(".gallery-block .bottom-slider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: false,
    arrows: false,
   
  });


  $(".reviews-slider").slick({
    accessibility: true,
    dots: false,
    slidesToShow: 1,
    infinite: true,
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
        }
      },
    ],
  });

  $(".slider-blog-start").slick({
    accessibility: true,
    slidesToShow: 1,
    infinite: true,
    fade: true,
    arrows: true,
    asNavFor: ".slider-block__small-slider",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 3000,
          adaptiveHeight: false,
        }
      },
    ],
  });

  $(".slider-block__small-slider").slick({
    accessibility: true,
    slidesToShow: 1,
    infinite: true,
    fade: true,
    arrows: false,
    asNavFor: ".slider-blog-start",
  });

  $(".gallery-block__slider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: true,
    arrows: true,
  });

  // ==== MENU FUNCTIONALITY
  const toggleMenu = () => {
    let navigation = document.querySelector(".navigation");
    let header = document.querySelector(".header");
    navigation.classList.toggle("active");
    header.classList.toggle("active");
  };


  if (document.querySelector(".js-menu-button")) {
    const menuButton = document.querySelector(".js-menu-button");
    menuButton.addEventListener("click", () => {
      toggleMenu();
      menuButton.classList.toggle("open");

      let buttonText = menuButton.querySelector("span");

      menuButton.classList.contains("open")
        ? (buttonText.innerText = "close")
        : (buttonText.innerText = "menu");
    });
  }
  //MOBILE MENU FUNCTIONALITY
  if(document.querySelector('.js-mobile-menu')) {
    document.querySelector(".js-mobile-menu").addEventListener("click", (e) => {
      console.log(e.target);
      toggleMenu();
    });
  }//END MOBILE MENU FUNCTIONALITY
  // ==== END MENU FUNCTIONALITY


  //ACCOMMODATIONS FILTER FUNCTIONALITY
  const clearOptions = (items) => {
    items.forEach((item) => {
      item.classList.contains("active")
        ? item.classList.remove("active")
        : null;
    });
  };

  const updateAccommodations = (tag) => {
    let accommodations = document.querySelectorAll(
      ".accommodations-list__unit"
    );

    accommodations.forEach((item) => {
      if (item.dataset.tag !== tag) {
        item.classList.add("hidden");
      } else {
        item.classList.remove("hidden");
      }
    });
  };

  if (document.querySelector(".accommodations-list .filter-row__option")) {
    let filterOptions = document.querySelector(
      ".accommodations-list .filter-row__option"
    );
    let items = filterOptions.querySelectorAll("li");

    filterOptions.addEventListener("click", (e) => {
      if (e.target.nodeName == "LI") {
        let element = e.target;
        let tag = element.dataset.tag;

        clearOptions(items);
        element.classList.add("active");
        updateAccommodations(tag);
      }
    });
  }
  //END ACCOMMODATIONS FILTER  FUNCTIONALITY

  //FILTER COLUMNS FUNCTIONALITY
  const firstLoad = (filterOptions) => {
    filterOptions[0].classList.add("active");
    filterOptions[0].click();
  };

  const toggleActiveOptions = (currentActive, items) => {

    items.forEach((item) => {
      //Remove active class to all Filter Options
      item.classList.contains("active")
        ? item.classList.remove("active")
        : null;
    });

    //Add "Active class To clicked filter Option"
    currentActive.classList.add("active");
  };

  const updateItemsOnScreen = (targetTag = 'all', items) => {
    items.forEach((item) => {
      //remove "hidden" class on All items
      
      item.classList.contains("hidden")
      ? item.classList.remove("hidden")
      : null;

      if(targetTag !== 'all') {
        if (item.dataset.tag !== targetTag) {
          //Add "hidden" class to elements that doesn't match Tag
          item.classList.add("hidden");
        }
      }
    });
  };

  //This condition validates if the filter-columns shortcode exist in DOM
  //If exist, launch the fistLoad and create the listener for filter options
  if (document.querySelector(".filter-columns")) {
    let filterOption = document.querySelector(".filter-columns .filter-row");
    let items = document.querySelectorAll(
      ".filter-columns .filter-columns__items .item"
    );

    window.addEventListener("load", () =>
      firstLoad(filterOption.querySelectorAll("li"))
    );


    //Event Propagation
    filterOption.addEventListener("click", (e) => {
      if (e.target.nodeName == "LI") {

        let target = e.target.dataset.tag;
        if(target !== 'all') {
          toggleActiveOptions(e.target, filterOption.querySelectorAll("li"));
          updateItemsOnScreen(target, items);
        } else {
          toggleActiveOptions(e.target, filterOption.querySelectorAll("li"));
          updateItemsOnScreen('all', items);
        }
      }

    });

    //This condition only runs on mobile devices and it's used to update the custom select
    if(document.querySelector('.filter-columns .js-mobile-filter-columns')) {
      let mobileCustomSelect = document.querySelector('.filter-columns .js-mobile-filter-columns');

      console.log(mobileCustomSelect);
    
      // filterOption.querySelectorAll("li").forEach( item => {
      //   item.classList.contains('active')
      //   ? mobileCustomSelect.innerText = item.innerText
      //   : null;
      // });

      mobileCustomSelect.addEventListener('click', () => {
        filterOption.querySelector('ul').classList.toggle('opened');
      });
    }
    //End of mobile condition

  }
  //END FILTER COLUMNS FUNCTIONALITY

  //LOCATION MAP HOMEPAGE FUNCTIONALITY
  const firstMapLoad = (actionButtons) => {
    actionButtons[0].click();
  };

  const updateMap = (tag, pinsArray) => {
    pinsArray.forEach((pin) => {
      //Hide All pins in map
      !pin.classList.contains("hidden") ? pin.classList.add("hidden") : null;

      if (pin.dataset.tag === tag) {
        pin.classList.remove("hidden");
      } else {
        pin.classList.add("hidden");
      }
    });
  };

  function removeActiveElements( buttons ) {
    buttons.forEach(( button ) => {

      button.classList.contains('active')
        ? button.classList.remove('active')
        : null;

    })
  }

  if (document.querySelector(".location-map-block")) {
    let pins = document.querySelectorAll(".location-map-block .pin");
    let pinsArray = [...pins]; //turn Node List  in to a normal array
    let actionButtons = document.querySelectorAll(".map_locations__list li");

    actionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        removeActiveElements(actionButtons);
        button.classList.add('active');
        const tag = button.dataset.tag;
        updateMap(tag, pinsArray);
      });
    });

    firstMapLoad(actionButtons);
  }
  //END LOCATION MAP HOMEPAGE FUNCTIONALITY


  //CUSTOM ATTRACTIONS FUNCTIONALITY
  const updateAttractionsMap = ({ pins, tag }) => {
    pins.forEach((pin) => {
      !pin.classList.contains("hidden") ? pin.classList.add("hidden") : null;
      pin.dataset.tag === tag ? pin.classList.remove("hidden") : null;
    });
  };


  const showContent = (tag, rows) => {

    rows.forEach((row) => {
      !row.classList.contains("hidden") ? row.classList.add("hidden") : null;

      if (row.dataset.tag === tag) {
        row.classList.remove("hidden");
      }

    });

  };


  const clearFilter = (filter) => {
    let options = filter.querySelectorAll("li");
    options.forEach((option) => option.classList.remove("active"));
  };

  function closePins( pins ) {
    
    pins.forEach( pin => {
      pin.classList.contains('active')
        ? pin.classList.remove('active')
        : null;
    })
  }

  const findActivePin = ({ neededTag, pins }) => {

    console.log({ neededTag, pins });

    pins.forEach(( pin ) => {
      if(pin.dataset.title === neededTag) {
        pin.classList.add('active');
      }
    })
  }

  if (document.querySelector(".attractions-map")) {
    
    let pins = document.querySelectorAll(".js-pin");
    pins = [...pins];
    let mapBox = document.querySelector('.map-pins');
    let filterOptions = document.querySelector(".js-filter-column");
    let contentRows = document.querySelectorAll(".js-bottom-row");
    let bottomList = document.querySelectorAll(".bottom-container .js-list-item");
    let infoLightboxes = document.querySelectorAll('.attractions-map .js-pin-info');
    let closeButtons = document.querySelectorAll('.attractions-map .js-pin-info .exit-button');

    function obtenerCuadrante(elementPrincipal, elementTarget) {
      const rectPrincipal = elementPrincipal.getBoundingClientRect();
      const rectObTarget = elementTarget.getBoundingClientRect();
  
      const MidPointX = (rectPrincipal.left + rectPrincipal.right) / 2;
      const MidPointY = (rectPrincipal.top + rectPrincipal.bottom) / 2;
    
      if (rectObTarget.top <= MidPointY && rectObTarget.left <= MidPointX) {
        return "top-right";
      } else if (rectObTarget.top <= MidPointY && rectObTarget.right >= MidPointX) {
        return "top-left";
      } else if (rectObTarget.bottom >= MidPointY && rectObTarget.left <= MidPointX) {
        return "bottom-right";
      } else if (rectObTarget.bottom >= MidPointY && rectObTarget.right >= MidPointX) {
        return "bottom-left";
      } else {
        return "NoCuadrant";
      }
    }

    pins.forEach( pin => {
      let cuadrant = obtenerCuadrante(mapBox , pin)
      pin.classList.add(cuadrant)
    })

    filterOptions.addEventListener("click", (e) => {

      if (e.target.nodeName === "LI") {

        let tag = e.target.dataset.tag;
        updateAttractionsMap({ pins, tag });
        showContent(tag, contentRows);
        clearFilter(filterOptions);
        e.target.classList.add("active");

      }

      if (e.target.classList.contains('title') && window.innerWidth <= 640) {
        let optionsList = document.querySelector('.js-filter-column ul');
        optionsList.classList.toggle('active');
        e.target.classList.toggle('active');
      }
    });

    bottomList.forEach( item => {

      item.addEventListener('click', () => {
        const neededTag = item.dataset.title;
        console.log({ neededTag });
        closePins(pins);
        findActivePin({ neededTag, pins });
      })

    });

    pins.forEach( pin => {

      pin.addEventListener('click', (e) => {
        // console.log(pin);
        if(e.target.nodeName === 'SPAN') {

          closePins(pins);
          !pin.classList.contains('active')
            ? pin.classList.add('active')
            : null;

        } else {
          if(e.target.classList.contains('exit-button')) {
            console.log(e.target.classList.contains('exit-button'));
            closePins(pins)
          }
        }
      })
    })

    

    infoLightboxes.forEach( box => {
      let boxWidth    = box.clientWidth;
      let boxHeight   = box.clientHeight;
      let container   = box.parentNode;

      if(container.classList.contains('bottom-left') ) {
        box.style.top = `-${boxHeight + 40}px`;
        box.style.right = '10px'
      } else if(container.classList.contains('top-left')) {
        box.classList.add('top-left');
        box.style.bottom = `-${boxHeight + 40}px`;
        box.style.right = `10px`;
      } else if(container.classList.contains('top-right')) {
        box.style.bottom = `-${boxHeight + 40}px`;
        box.style.left = `10px`;
      } else if(container.classList.contains('bottom-right')) {
        box.classList.add('bottom-right');
        box.style.top = `-${boxHeight + 40}px`;
        box.style.left = `10px`;
      }
    })

    filterOptions.querySelectorAll("li")[0].click(); //simulate click on the first item in the list of filter options

    //Close Lightboxes with close buttons
    closeButtons.forEach( button => {
      button.addEventListener('click', () => {

        let parent = button.parentElement.parentElement;
        parent.classList.remove('active')

      })
    });
  }
  //END CUSTOM ATTRACTIONS FUNCTIONALITY
 

  //FORMS LABEL FUNCTIONALITY
  if(document.querySelector('.form-module-wrapper')) {
    let form    = document.querySelector('.form-module-wrapper'),
        fields  = document.querySelectorAll('.form-module__field input');
        fields  = [...fields, ...document.querySelectorAll('.form-module__field textarea')];

    fields.forEach( field => {

      const label = field.previousElementSibling

      field.addEventListener('focus', () => {
        label.style.transition = 'all .3s ease-in-out';
        label.style.top = '-20px';
        label.style.fontSize = '14px';
      });
    });
  }
  //END FORMS LABEL FUNCTIONALITY


  // HEADER NAVIGATION OVERLAY FUNCTIONALTY
  const showOverlay = ( overlay ) => {
    overlay.style.opacity = '1';
  }

  const hideOverlay = ( overlay ) => {
    overlay.style.opacity = '0';
  };

  const checkItems = ( navigationLinks, overlay ) => {

    navigationLinks.forEach( item => {

      item.addEventListener('mouseover', (e) => {
        showOverlay( overlay);
      });

      item.addEventListener('mouseout', () => {
        hideOverlay( overlay );
      });

    });

  };

  const NAVIGATION = document.querySelector('.navigation');
  const navigationLinks = document.querySelectorAll('.navigation .privary-navigation__list > li');
  const SUBMENU_LINKS = document.querySelectorAll('.navigation .sub-menu li');
  let overlay = NAVIGATION.querySelector('.navigation-overlay-js');

  checkItems( navigationLinks, overlay);
  checkItems( SUBMENU_LINKS, overlay);

  // HEADER NAVIGATION OVERLAY FUNCTIONALITY

  
  //Add data-content attribute to navigation links
  // if( window.innerWidth > 1200) {
    navigationLinks.forEach( item => {
      const newSpan = document.createElement('span');
      newSpan.textContent = item.firstElementChild.innerText;
      item.querySelector('a').innerText = '';
      item.querySelector('a').appendChild(newSpan);
      item.querySelector('a').dataset.content = item.firstElementChild.innerText;
    })
  // }

  const SUBNAV = document.querySelector('.sub-menu');

  if (SUBNAV) {
    SUBNAV.querySelectorAll(".submenu").forEach(subSubmenu => {
      subSubmenu.previousElementSibling.addEventListener("click", function(e) {
        e.preventDefault();
  
        this.classList.toggle("active");
      });
    });
  
    if (window.innerWidth <= 1024) {
  
      SUBNAV.dataset.selected = (SUBNAV.querySelector(".active") || SUBNAV.querySelector("a")).textContent;
  
      SUBNAV.addEventListener("click", function(e) {
        e.target === this && this.classList.toggle("active");
      });
    }
  }

  //MOBILE SUBMENU FUNCTIONALITY
  /* if(document.querySelector('.sub-menu') && window.innerWidth <= 1024){

    let newElement = document.createElement('div')
    newElement.classList.add('js-mobile-subnav');
    newElement.innerHTML = '<span>Accommodations</span></i>';

    const parent = document.getElementById('content');
    console.log(parent);

    parent.insertBefore(newElement, document.querySelector('.sub-menu'));

    const submenuBtn = document.querySelector('.js-mobile-subnav');
    let submenu = submenuBtn.nextElementSibling;

    submenuBtn.addEventListener('click', () => {
      console.log( submenu );
      submenu.classList.toggle('active');
    });


    window.addEventListener('load', () => {
      const label = document.querySelector('.js-mobile-subnav span');
      submenu.querySelectorAll('li a').forEach( item => {
        item.classList.contains('active')
          ? label.innerText = item.innerText
          : null;
      });

    })

  } */
//END MOBILE SUBMENU FUNCTIONALITY

//ANCHOR LINKS FUNCTIONALITY
  const hasParameters = ( url ) => {
    return url.indexOf('?') > -1; //returns true if the url has parameters
  }

  const getParameters = ( url ) => {
    let parameters = url.split('?')[1]; //get the parameters of the url
    return parameters.split('&');// return an array with the parameters
  }

  function getFilterTabs() {
    let filterOptions
    let filterOptionsArray
    let doScroll

    if(document.body.id === 'default') {
      console.log('default');

      if(document.querySelectorAll('.js-filter-column .js-filter-option')) { //check if the filter columns shortcode exist in DOM
        filterOptions = document.querySelectorAll('.js-filter-column .js-filter-option');
        filterOptionsArray = [...filterOptions]; //turn Node List in to a normal array
      }
    } else if(document.body.id === 'home') {
      // console.log('home');
      if(document.querySelector('.location-map-block')) { //check if the filter columns shortcode exist in DOM
        // console.log("HOMEPAGE");
        filterOptions = document.querySelectorAll('.location-map-block li');
        filterOptionsArray = [...filterOptions]; //turn Node List in to a normal array
        doScroll = true;

      }
    }

    return { filterOptionsArray, doScroll };

  }

  function replaceAmperSand( tag ) {
    const regex = new RegExp("&", "g"); //create a regex to find all the ampersands
    tag = tag.replace(regex, 'and');

    return tag;// replace all the ampersands with the word "and"
  }

  function showTabsInParameters( parameterName, parameterValue ) {

    switch (parameterName) {
      case 'tab':

        const { filterOptionsArray, doScroll } = getFilterTabs(); //get the filter options

        filterOptionsArray.forEach( option => {

          if(option.dataset.tag.includes('&')) {
            console.log( option);
            let newTag = replaceAmperSand( option.dataset.tag );

            newTag === parameterValue //check if the tag matches the parameter value
              ?  option.click() //simulate click on the option
              :  null;

          } else {
            option.dataset.tag === parameterValue //check if the tag matches the parameter value
              ?  option.click() //simulate click on the option
              :  null;
          }

        })

        if (doScroll) {
          let target = document.querySelector('.location-map-block');
          let targetY = target.getBoundingClientRect().top - 90;
          let targetX = target.getBoundingClientRect().left;
          
          window.scroll(targetX, targetY);
        }

        break;

      default:

        return;

        break;
    }
  };


  const currentURl = window.location.href //get the current url
  let existParameters = hasParameters( currentURl );//get result of hasParameters function, true or false

  if( existParameters ) {
    let parametersCollection = getParameters( currentURl ); //get the parameters of the url
    console.log({ parametersCollection });

    let parameterName,
        parameterValue
    
    parametersCollection.forEach( parameter => {
      parameterName = parameter.split('=')[0]; //get the name of the parameter
      parameterValue = parameter.split('=')[1]; //get the value of the parameter
    });

    showTabsInParameters( parameterName, parameterValue );
  }
//END ANCHOR LINKS FUNCTIONALITY


//ACCOMODATIONS-LIST BUTTONS UPDATE
//This scripts get the buttons in the copy of each accommodations-list item and put it in to buttons-box
  if(document.querySelector('.accommodations-list')) {
    let accommodations = document.querySelectorAll('.accommodations-list__unit');

    accommodations.forEach( item => {
      let buttonsBox = item.querySelector('.accommodations-list .buttons-box');
      let buttons = item.querySelectorAll('.accommodations-list__unit .btn');

      buttons.forEach( button => {
        buttonsBox.appendChild(button);
      });

    });
  }

  if(document.querySelector('.js-current-option.filter-row__current-option')){
    const mobileFilter = document.querySelector('.js-current-option.filter-row__current-option');
    const filterOptions = document.querySelector('.filter-row__option ul');
    const filterOptionsItems = filterOptions.querySelectorAll('li');

    console.log({ mobileFilter });

    mobileFilter.addEventListener('click', (e) => {

      if( e.target.nodeName === 'SPAN') {
        filterOptions.classList.toggle('active');
      }

    })

    filterOptions.addEventListener('click', (e) => {
      if(e.target.nodeName === 'LI') {
        mobileFilter.querySelector('span').innerText = e.target.innerText;
        filterOptions.classList.toggle('active');
      }
    })

  }
//END ACCOMODATION-LIST BUTTONS UPDATE


//OPEN ALL ACCORDION ITEMS ON FIRTS LOAD
  if(document.querySelector('.accordion-block') && document.body.classList.contains('page80557')) {
    const accordion = document.querySelector('.accordion-block');
    const accordionTitle = accordion.querySelectorAll('.accordion-block .js-accordion-title');

    accordionTitle.forEach( title => {
      title.click();
    });
  }
//END OPEN ALL ACCORDION ITEMS ON FIRTS LOAD


  // if(document.querySelector('.accommodations-overview__text .btn')) {
  //   document.querySelector('.accommodations-overview__text .btn').addEventListener('click', (e) => {
  //     console.log(e.target);
  //   })

  //   document.querySelector('.slider-block__text .btn').addEventListener('click', (e) => {
  //     console.log(e.target);
  //   })
  // }

  let booknowButtonMobile = document.querySelector("#list-book-now");

  if(booknowButtonMobile){
    booknowButtonMobile.addEventListener("change", (e) =>{
      let link = e.target.value;

      document.location = link;
    })
  }



})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
  const menu = document.querySelector('.navigation');
  const isMenuVisible = menu && menu.classList.contains('active');
  const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .social-media a');

  elements.forEach(element => {
      element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
  });
}


document.addEventListener('DOMContentLoaded', () => {
  updateMenuTabIndex();


  document.addEventListener('focusin', updateMenuTabIndex);
  const menu = document.querySelector('.navigation');
  if (menu) {
      menu.addEventListener('transitionend', updateMenuTabIndex);
  }
});


function getItemsColumnsByTabs( module, blog_id, containerColumns, secondary_title = '', tag = 'all' ){
  if( !module || !blog_id || !containerColumns )
    return false;

    fetch(`${site_url}ajax/functions.php?operation=getItemsColumnsByTabs&blog_id=${blog_id}&secondary_title=${secondary_title}&tag=${tag}`)
      .then( data => data.json() )
      .then( response => {
        if( response.error == false ){
          containerColumns.innerHTML = response.html;
        }else{
          containerColumns.innerHTML = `<p class="error">Something went wrong</p>`;;
          console.error(`Error in module #${module.id}. Message: ${response.err_msg}`);
        }
        containerColumns.classList.remove(`half-opacity`);
        $(".sym-slides").slick({
          accessibility: false,
        });
      } )
}

function columnWithTabs(){
  const allColumnsTabsModule = document.querySelectorAll(`.js-columnsTabs_module`);
  allColumnsTabsModule.forEach( module => {
    let secondary_title   = module.dataset.secondary_title,
        blog_id           = module.dataset.blog_id,
        no_tags           = module.dataset.no_tags,
        filter            = module.querySelector(`.js-columnsTabs_filter`),
        containerColumns  = module.querySelector(`.js-columnsTabs_inner`);

        if( no_tags ){
          getItemsColumnsByTabs( module, blog_id, containerColumns, secondary_title );
        }else{
          filter.addEventListener('click', e => {
            let elementClicked = e.target;
            if( elementClicked.nodeName == 'LI' ){
              containerColumns.classList.add(`half-opacity`);
              if(filter.querySelector('li.active'))
                filter.querySelector('li.active').classList.remove('active')
              elementClicked.classList.add('active')

              let tag = elementClicked.dataset.tag;
              getItemsColumnsByTabs( module, blog_id, containerColumns, secondary_title, tag );
            }
          })

          filter.querySelector('li').click();
        }
  } );
}

document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector(`.js-columnsTabs_module`)){
    columnWithTabs();
  }
});